// =====================================================
// COMPOSANT: ExportCsvButton — export CSV du dashboard (RUN 6)
// =====================================================
// Exporte les CHIFFRES AFFICHÉS du dashboard en respectant les filtres actifs
// (plage de dates via les data déjà calculées, toggle N-1). Réutilise
// l'utilitaire CSV existant du CRM (`exportToCSV` : « ; » + BOM Excel FR). La
// construction des lignes est déléguée à la couche pure `buildDashboardCsvRows`.

import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { exportToCSV } from '@/lib/csv';
import { toast } from '@/components/ui';
import {
  buildDashboardCsvRows,
  dashboardCsvFilename,
  type ConversionData,
  type AppelsData,
  type GlobalKpis,
  type OriginData,
  type RomainData,
} from '@/lib/dashboard-stats';

interface ExportCsvButtonProps {
  kpis: GlobalKpis;
  conversion: ConversionData | null;
  appels: AppelsData | null;
  origin: OriginData | null;
  romain: RomainData | null;
  showN1: boolean;
  rangeLabel: string;
  editionName: string;
  disabled?: boolean;
}

export function ExportCsvButton({
  kpis,
  conversion,
  appels,
  origin,
  romain,
  showN1,
  rangeLabel,
  editionName,
  disabled,
}: ExportCsvButtonProps) {
  const handleExport = () => {
    const rows = buildDashboardCsvRows({
      kpis,
      conversion,
      appels,
      origin,
      romain,
      showN1,
      rangeLabel,
      editionName,
    });
    if (rows.length === 0) {
      toast.error('Aucune donnée à exporter');
      return;
    }
    exportToCSV(rows, dashboardCsvFilename({ editionName, rangeLabel }), {
      silentEmpty: true,
    });
    toast.success('Export CSV généré', {
      description: `${rows.length} lignes · ${editionName} · ${rangeLabel}`,
    });
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={handleExport}
      disabled={disabled}
      className="gap-1.5"
    >
      <Download className="h-4 w-4" />
      Exporter CSV
    </Button>
  );
}
